import { render, staticRenderFns } from "./CircularMailCustomerModal.vue?vue&type=template&id=15879464&scoped=true&"
import script from "./CircularMailCustomerModal.vue?vue&type=script&lang=babel&"
export * from "./CircularMailCustomerModal.vue?vue&type=script&lang=babel&"
import style0 from "./CircularMailCustomerModal.vue?vue&type=style&index=0&id=15879464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15879464",
  null
  
)

export default component.exports